const menu = {
  key: "seleccionBobinasPvs",
  route: "/legacy/seleccion-bobinas-pvs",
  label: "sidebar.seleccionBobinasPvs",
  icon: "faLayerGroup",
  group: "sales",
  order: 21.5,
  permission: "legacy.salesorder.read"
};

export default menu;
